import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'

export type PillTone = 'green' | 'gray' | 'amber' | 'blue' | 'red'

const TONES: Record<PillTone, { box: string; dot: string }> = {
  green: { box: 'bg-emerald-50 text-emerald-700', dot: 'bg-emerald-500' },
  gray:  { box: 'bg-gray-100 text-gray-600', dot: 'bg-gray-400' },
  amber: { box: 'bg-amber-50 text-amber-800', dot: 'bg-amber-500' },
  blue:  { box: 'bg-brand-50 text-brand-700', dot: 'bg-brand-500' },
  red:   { box: 'bg-rose-50 text-rose-700', dot: 'bg-rose-500' },
}

/** Selo com ponto colorido e texto — o texto é o que diz o estado (cor não basta). */
export function Pill({ tone, children, dot = true, className }: {
  tone: PillTone
  children: ReactNode
  dot?: boolean
  className?: string
}) {
  const t = TONES[tone]
  return (
    <span className={cn('inline-flex h-[22px] items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 text-xs font-medium', t.box, className)}>
      {dot && <span aria-hidden className={cn('h-1.5 w-1.5 rounded-full', t.dot)} />}
      {children}
    </span>
  )
}

/**
 * Status ATIVO/INATIVO por extenso. `feminine` para "Ativa/Inativa"
 * (categoria, tipologia, cobertura, opção, curva).
 */
export function StatusPill({ status, feminine = false }: { status: string | null | undefined; feminine?: boolean }) {
  const on = status === 'ATIVO'
  return <Pill tone={on ? 'green' : 'gray'}>{on ? (feminine ? 'Ativa' : 'Ativo') : (feminine ? 'Inativa' : 'Inativo')}</Pill>
}
